var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.type === "bar"
    ? _c("md-progress-bar", {
        staticClass: "ui-progress-bar",
        style: { height: _vm.stroke + "px" },
        attrs: {
          "md-buffer": _vm.buffer,
          "md-mode": _vm.mode,
          "md-value": _vm.value,
        },
      })
    : _vm.type === "dots"
    ? _c("div", { staticClass: "ui-progress-dots" }, [
        _c("div", { staticClass: "bounce1" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce2" }),
        _vm._v(" "),
        _c("div", { staticClass: "bounce3" }),
      ])
    : _c("md-progress-spinner", {
        staticClass: "ui-progress-spinner",
        attrs: {
          "md-diameter": _vm.diameter,
          "md-mode": _vm.mode,
          "md-stroke": _vm.stroke,
          "md-value": _vm.value,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }